import type { ReactNode } from 'react';
import Breadcrumb, { type Crumb } from '@/components/feature/Breadcrumb';

interface PageHeroProps {
  eyebrow: string;
  title: string;
  desc: string;
  crumbs: Crumb[];
  children?: ReactNode;
}

export default function PageHero({ eyebrow, title, desc, crumbs, children }: PageHeroProps) {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="container-page py-8 md:py-12">
        <Breadcrumb items={crumbs} />
        <div className="mt-5 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-800">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-live-line" aria-hidden="true" />
              </span>
              {eyebrow}
            </span>
            <h1 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-[40px]">
              {title}
            </h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
          </div>
          {children && <div className="shrink-0">{children}</div>}
        </div>
      </div>
    </section>
  );
}